import React from "react";
import { NonIdealState, Button, Intent, TextArea } from "@blueprintjs/core";
// eslint-disable-next-line
import _ from "lodash";
import Slider from '@material-ui/core/Slider';
import { translate } from "utlis/translations/i18n";

const marks = [
  {
    value: 1,
    label: '1',
  },
  {
    value: 2,
    label: '2',
  },
  {
    value: 3,
    label: '3',
  },
  {
    value: 4,
    label: '4',
  },
  {
    value: 5,
    label: '5',
  },
  {
    value: 6,
    label: '6',
  },
  {
    value: 7,
    label: '7',
  },
  {
    value: 8,
    label: '8',
  },
  {
    value: 9,
    label: '9',
  },
  {
    value: 10,
    label: '10',
  },
];

class MultipleScaleVote extends React.Component {
  constructor(props) {
    super(props);
    this.state = { voted: false };
  }
  //   initializeVotedFor = () => {
  //     const { votedFor, session, onVote } = this.props;
  //     const { data } = session;
  //     const { msCriterias = [] } = data;
  //     const initialVotedFor = {};

  //     if (votedFor != null) return;
  //     // The user hasn't voted yet. We initialize the vote to handle
  //     // the case in which the user is agree with default values
  //     msCriterias.map(c => (initialVotedFor[c.id] = c.default));
  //     onVote(initialVotedFor);
  //   };
  initializeVotedFor = () => {
    let { votedFor, session, instance } = this.props;
    const { currentSequence } = instance;
    const { data } = session;
    const { msCriterias = [] } = data;
    const initialVotedFor = {};

    if (votedFor == null) votedFor = {};
    msCriterias.map(c => (initialVotedFor[c.id] = votedFor[c.id] || c.default));
    this.setState({ [currentSequence]: initialVotedFor, voted: false });
  };
  updateVotedFor = () => {
    const { votedFor, session, instance } = this.props;
    const { currentSequence } = instance;
    const { data } = session;
    const { msCriterias = [] } = data;
    const initialVotedFor = {};
    if (this.state[currentSequence]) return;
    msCriterias.map(
      c =>
        (initialVotedFor[c.id] = votedFor == null ? c.default : votedFor[c.id])
    );
    this.setState({ [currentSequence]: initialVotedFor });
  };

  handleChangeSlider = (id, value) =>
    this.props.onVote({ ...this.props.votedFor, [id]: value });

  render() {
    const { session, className } = this.props;
    const { metadata, data } = session;
    const { msCriterias = [] } = data;
    let { votedFor = {} } = this.props;

    if (votedFor == null) votedFor = {};
    if (msCriterias.length === 0)
      return (
        <NonIdealState
          icon="warning-sign"
          title="Aucun critères de votes"
          description="The operator did not enter a voting criterion. Thank you for pointing out to him."
        />
      );
    return (
      <div className={className}>
        <div className="context text-center margin-bottom-large" style={{ fontSize: '25px' }}>{metadata.context}</div>
        {(this.state.voted && metadata.type === 'PILOTED')
          ?
          <h3 className='text-center'>{translate('thanksForParticipationPleaseWaitOthers')}</h3>
          :
          <div>
            {msCriterias.map((c, index) => {
              const { currentSequence } = this.props.instance;
              let defaultValue = c.default;
              if (this.state[currentSequence] && this.state[currentSequence][c.id])
                defaultValue = this.state[currentSequence][c.id];
              return (
                <div key={index} className="margin-top-medium vote-slider">
                  <div className="label" style={{ marginBottom: "15px", fontSize: '20px' }}>{c.name}</div>
                  {(!c.type || c.type === 'CLOSE') ?
                    <>
                      <Slider
                        min={c.min}
                        max={c.max}
                        value={defaultValue}
                        name={c.name}
                        step={1}
                        valueLabelDisplay="auto"
                        marks={marks}
                        color='white'
                        onChange={(event, value) =>
                          this.setState({
                            [currentSequence]: {
                              ...this.state[currentSequence],
                              [c.id]: value,
                            }
                            , voted: false
                          })
                        }
                      />
                      {c.minCaption && (
                        <span style={{ display: 'flex', justifyContent: 'space-between', fontSize: '17px' }}>
                          <div>
                            {c.minCaption}
                          </div>
                          <div>
                            {c.maxCaption ? c.maxCaption : ''}
                          </div>
                        </span>
                      )}
                    </>
                    :
                    <TextArea
                      className='bp3-fill'
                      growVertically={true}
                      id="feedback-question"
                      name="question"
                      value={defaultValue}
                      onChange={e =>
                        this.setState({
                          [currentSequence]: {
                            ...this.state[currentSequence],
                            [c.id]: e.target.value,
                          }, voted: false
                        })
                      }
                    />
                  }
                </div>
              );
            })}
            <div className="text-center margin-top-large margin-bottom-medium">
              <Button
                style={{ marginTop: "10px" }}
                intent={this.state.voted ? Intent.SUCCESS : Intent.PRIMARY}
                onClick={() => {
                  this.props.onVote(this.state[this.props.instance.currentSequence])
                  this.setState({ voted: true })
                }
                }
              >
                {translate('enter')}
          </Button>
              {/* {this.state.voted === true ?
            <p className='margin-top-small'>Thank you for your vote, you can still change the values ​​and validate again</p>
            :
            ''
          } */}
            </div>
          </div>
        }
      </div>
    );
  }

  componentDidMount() {
    this.initializeVotedFor();
  }
  componentDidUpdate() {
    this.updateVotedFor();
  }
  componentWillReceiveProps(nextProps) {

    if (nextProps.instance !== this.state.instance && this.state.voted) {
      this.setState({ voted: false });
    }
  }

}
export default MultipleScaleVote;
